import OnDOMReady from "shared/util/OnDOMReady";
import isSpa from "shared/util/isSpa";
import addToGlobalStore from "shared/redux/addToGlobalStore";
import addToGlobalAnalyticsMiddleware from "shared/redux/addToGlobalAnalyticsMiddleware";
import globalMessaging from "ducks/global_messaging";
import globalMessagingAnalytics from "analytics/global_messaging";
import GlobalMessaging from "features/global_messaging";

OnDOMReady(() => {
	if (isSpa()) {
		return;
	}

	addToGlobalStore({ globalMessaging });
	addToGlobalAnalyticsMiddleware({ globalMessaging: globalMessagingAnalytics });

	GlobalMessaging.init();
});



// WEBPACK FOOTER //
// ./src/features/global_messaging/setup.js